export enum SalesActionEnum {
  New = 1,
  Renew = 2,
  Convert = 3,
  Extend = 4,
  Adjustment = 5,
  DepositReplenishment = 6,
}
